import { Paper, Box, Typography } from "@mui/material";

export const SideCard: React.FC<{
    title?: string;
    children: React.ReactNode;
    action?: React.ReactNode;
}> = ({ title, children, action }) => (
    <Paper
        elevation={0}
        sx={{
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            p: 2,
            bgcolor: "#fff",
        }}
    >
        {title && (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                }}
            >
                <Typography fontWeight={700} fontSize="13px">
                    {title}
                </Typography>
                {action}
            </Box>
        )}
        {children}
    </Paper>
);